















import Toolbar from '@/components/Toolbar.vue';
import { MappedItems } from '@/mapping/MappedItems';
import UnmappedTable from '@/mapping/UnmappedTable.vue';
import { transform } from 'lodash';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  components: {
    Toolbar,
    UnmappedTable,
  },
})
export default class UnmappedDatapoints extends Vue {
  private async created() {
    await this.$store.dispatch('bindUnmappedDatapoints');
  }

  private destroyed() {
    this.$store.dispatch('unbindUnmappedDatapoints');
  }

  private get unmappedQuestionLabels() {
    return this.$store.getters.questionLabelsWithoutDatapoints;
  }

  private async save(changedItems: MappedItems) {
    await this.$store.dispatch('mapUnmappedDatapoints', {
      mapping: transform(changedItems, (result, value, key) => {
        result[key] = value.toLowerCase();
      }, {} as MappedItems),
    });
  }
}
